import axios from 'axios';

// Em produção, usar URL relativa (o Apache faz proxy)
// Em desenvolvimento, usar REACT_APP_API_URL ou localhost
let baseURL;
if (process.env.NODE_ENV === 'production') {
  // Em produção, usar window.location.origin (mesmo domínio)
  // O Apache fará proxy de /api para localhost:5000
  baseURL = typeof window !== 'undefined' ? window.location.origin : '';
} else {
  // Em desenvolvimento, usar variável de ambiente ou localhost
  baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
}

// Garantir que baseURL não tenha /api no final (será adicionado nas rotas)
const cleanBaseURL = baseURL.endsWith('/api') ? baseURL.slice(0, -4) : baseURL;

const api = axios.create({
  baseURL: cleanBaseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 segundos de timeout (aumentado para operações mais lentas)
});

// Interceptor para adicionar token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Só redirecionar para login se for erro 401 (não autorizado)
    // Não redirecionar para outros erros (500, 404, etc)
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      // Evitar loop de redirecionamento
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    
    // Não logar erro 404 em buscas de cliente (comportamento esperado para clientes novos)
    if (error.response?.status === 404 && error.config?.url?.includes('/clientes/buscar/')) {
      // Silenciar o erro 404 para busca de cliente - é comportamento esperado
      // O erro ainda será rejeitado para que o código possa tratá-lo, mas não será logado
      return Promise.reject(error);
    }
    
    return Promise.reject(error);
  }
);

// Helper para construir URL completa de imagens
export const getImageUrl = (imagePath) => {
  try {
    // ✅ Se receber um objeto, extrair a propriedade url
    let urlString = imagePath;
    if (typeof imagePath === 'object' && imagePath !== null) {
      urlString = imagePath.url || imagePath.medium || imagePath.large || imagePath.thumbnail || imagePath.original || '';
    }
    
    if (!urlString || typeof urlString !== 'string') {
      return null;
    }
    
    // Se já é uma URL completa (http/https), retornar direto
    if (urlString.startsWith('http://') || urlString.startsWith('https://')) {
      return urlString;
    }
    
    // ✅ Em produção, usar window.location.origin (já aponta para o domínio correto)
    // Em desenvolvimento, usar REACT_APP_API_URL ou localhost
    let baseURL;
    if (typeof window !== 'undefined') {
      if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_API_URL) {
        baseURL = process.env.REACT_APP_API_URL;
      } else {
        baseURL = window.location.origin;
      }
    } else {
      baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    }
    
    // Limpar baseURL (remover /api se existir)
    let cleanBaseURL = baseURL;
    if (cleanBaseURL.endsWith('/api')) {
      cleanBaseURL = cleanBaseURL.slice(0, -4);
    }
    if (cleanBaseURL.endsWith('/')) {
      cleanBaseURL = cleanBaseURL.slice(0, -1);
    }
    
    // ✅ Garantir que urlString comece com /
    let finalPath = urlString;
    if (!finalPath.startsWith('/')) {
      finalPath = `/${finalPath}`;
    }
    
    // ✅ Se já começar com /uploads, usar direto (já está correto)
    // Se não começar com /uploads mas tiver produtos/, adicionar /uploads
    if (!finalPath.startsWith('/uploads')) {
      if (finalPath.includes('produtos/') || finalPath.includes('produto/')) {
        finalPath = `/uploads${finalPath}`;
      } else if (finalPath.startsWith('/produtos/')) {
        finalPath = `/uploads${finalPath}`;
      }
    }
    
    const finalUrl = `${cleanBaseURL}${finalPath}`;
    
    // ✅ Debug em desenvolvimento
    if (process.env.NODE_ENV === 'development') {
      console.log('🖼️ getImageUrl:', {
        original: imagePath,
        urlString,
        finalPath,
        finalUrl
      });
    }
    
    return finalUrl;
  } catch (error) {
    console.error('❌ Erro em getImageUrl:', error);
    return null;
  }
};

export default api;

